export const isVideo = (imageUrl: string): boolean => imageUrl.indexOf(".mp4") >= 0;
